import * as React from "react" 
import Button from "../components/Button"

export default function LatestPost({text, to}){
  return (
    <Button to={to}>
      <p className="fw-700 c-purple latest-post p-r mb-125r">{text}</p>
    </Button>
  )
}